import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  getAllEnvs() {
    const env = this.isBrowser
      ? (window as any).env
      : process.env;

    return env;
  }

  getEnvVar(key: string) {
    const env = this.isBrowser
      ? (window as any).env
      : process.env;

    return env[key];
  }

  getLopesNetProntosAutoLogin(): string {
    return `${this.getEnvVar('bff_login')}/legacy-login`;
  }

  getBaseLeadUrl(): string {
    return this.getEnvVar('base_url_lead');
  }

  getBasePortalUrl(): string {
    return this.getEnvVar('base_url_portal');
  }

  getBaseCrmUrl(): string {
    return this.getEnvVar('base_url_crm');
  }

  getToggle(toggleName: string) {
    if (!toggleName.startsWith('toggle_')) {
      throw new Error('toggles should start with "toggle_" prefix');
    }
    return this.getEnvVar(toggleName);
  }

}
